module.exports = __webpack_public_path__ + "img/cardMonitoring.8383c2c8.svg";